<template>
  <VDialog
    v-model="dialog"
    max-width="1200"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :hide-overlay="$vuetify.breakpoint.smAndDown"
  >
    <VCard
      :min-height="'100%'"
      class="overflow-hidden d-flex align-stretch"
      :class="{ 'd-flex align-center justify-center': $vuetify.breakpoint.mdAndUp }"
    >
      <VBtn
        fab
        icon
        right
        top
        absolute
        small
        class="mt-5 mr-n4"
        @click="dialog = false"
      >
        <VIcon>
          mdi-close
        </VIcon>
      </VBtn>
      <Skeleton v-if="loading" />
      <VContainer v-else-if="fetchStatus.fetchError">
        <VRow>
          <VCol cols="12">
            <VAlert type="error">
              {{ fetchStatus.fetchError }}
            </VAlert>
          </VCol>
        </VRow>
      </VContainer>
      <Candidate
        v-else-if="fetchStatus.isFetched && candidate"
        :vacancy="vacancy"
        :candidate="candidate"
        :show-neighbours="showNeighbours"
      />
    </VCard>
  </VDialog>
</template>

<script>
import useCandidates from '@/compositions/useCandidates';
import Skeleton from '../components/Candidate/Skeleton.vue';
import Candidate from '../components/Candidate/Candidate.vue';
import ValidationMixin from '../mixins/ValidationMixin';
import CandidateModel from '../orm/models/Candidate/Candidate';

export default {
  name: 'CandidatePage',
  components: { Candidate, Skeleton },
  mixins: [ValidationMixin],
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    candidateId: {
      type: [Number, String],
      required: true,
    },
    pushAfterClose: {
      type: Boolean,
      required: false,
      default: true,
    },
    showNeighbours: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup() {
    const { getCandidateTest } = useCandidates();

    return {
      getCandidateTest,
    };
  },
  data() {
    return {
      dialog: true,
      loading: true,
    };
  },
  computed: {
    fetchStatus() {
      return CandidateModel.getFetchStatus(this.candidateId);
    },
    candidate() {
      return CandidateModel.query()
        .withAllRecursive()
        .find(this.candidateId);
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.$emit('close');
        if (this.pushAfterClose) {
          this.$router.push({ name: 'candidates' });
        }
      }
    },
  },
  async created() {
    this.fetch(this.candidateId);

    await this.getCandidateTest(this.candidateId);
    if (!this.$vuetify.breakpoint.smAndUp) {
      document.body.classList.add('no-scroll');
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.loading = true;
    this.fetch(to.params.candidateId);
    next();
  },
  beforeDestroy() {
    if (this.vacancy?.id) {
      this.$store.commit('candidatePage/clearFrozenNeighbourIds', this.vacancy.id);
    }
    if (!this.$vuetify.breakpoint.smAndUp) {
      document.body.classList.remove('no-scroll');
    }
  },
  methods: {
    fetch(candidateId) {
      this.$nextTick(async () => {
        await CandidateModel.api().fetchById(candidateId);
        if (this.candidate?.testFinishedAt) {
          await this.getCandidateTest(this.candidateId);
        }
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.no-scroll {
  position: fixed;
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>
